import { all, fork } from 'redux-saga/effects';

export function* watchBoardListsPurePageSaga() {
  // yield takeLatest(constants.CREATE_BOARD_LIST, invokeCreateBoardList);
  // yield takeLatest(constants.UPDATE_BOARD_LIST, invokeUpdateBoardList);
  // yield takeLatest(constants.DELETE_BOARD_LIST, invokeDeleteBoardList);
  // yield takeLatest(constants.MOVE_BOARD_LIST, invokeMoveBoardList);
  // yield takeLatest(constants.INITIALIZE_TASK_PROPS, invokeInitializeTaskProps);
  // yield takeLatest(constants.CLEAR_TASK_PROPS, invokeClearTaskProps);
  // yield takeLatest(constants.CREATE_TASK, invokeCreateTask);
  // yield takeLatest(constants.UPDATE_TASK, invokeUpdateTask);
  // yield takeLatest(constants.DELETE_TASK, invokeDeleteTask);
  // yield takeLatest(constants.MOVE_TASK, invokeMoveTask);
  // yield takeLatest(constants.COPY_TASK, invokeCopyTask);
  // yield takeLatest(constants.SAVE_BOARD_LIST_SOCKET, invokeSaveBoardListSocket);
  // yield takeLatest(constants.DELETE_BOARD_LIST_SOCKET, invokeDeleteBoardListSocket);
  // // yield takeLatest(constants.SAVE_TASK_SOCKET, invokeSaveTaskSocket);
  // yield takeLatest(constants.MOVE_TASK_SOCKET, invokeMoveTaskSocket);
  // yield takeLatest(constants.COPY_TASK_SOCKET, invokeCopyTaskSocket);
}

export function* watchBoardListsPageStorageSaga() {
  yield all([watchBoardListsPurePageSaga].map(fork));
}
